import { Role } from '../../@types/auth';
import { useAuth } from '../../hooks/useAuth';
import { useNavigation } from './NavigationContext';

export const useNavItemVisibility = (requiredRoles: Role[], navTitle: string): boolean => {
    const { user } = useAuth();
    const { navItems } = useNavigation();

    const hasRole = requiredRoles.some(role => user?.hasRole(role));

    if (navItems.length === 0) {
        return hasRole;
    }

    const hasInNav = navItems?.some(item => item.title.toLowerCase().trim() === navTitle.toLowerCase().trim());

    return hasRole && hasInNav;
};
